/* 系统管理->资料库管理 */
<template>
  <div class="gggl">
    <div class="u-form">
      <template>
        <h4 style="color: aliceblue;margin-top: -30px">
          公告管理
        </h4>
      </template>
      <car-form @submit="submit" :showformitem="formitem">
        <template>
          <el-button type="success" size="small" @click="add(true)"
            >添加</el-button
          >
        </template>
      </car-form>
    </div>
        <hy-data-table
          v-model="loading"
          height="94%"
          ref="dataTable"
          @find-page="findPage"
          @detail-handle="detailHandle"
          @map-path="mapPath"
          @del="del"
          is-all-handle
          :data="dataTable.list"
          :columns="dataTable.columns"
          :extend-buttons="dataTable.buttons"
          :show-batch-delete="true"
          :show-operation="true"
          size="medium"
          :paging="dataTable.paging"
          :extend-but-widht="130"
        ></hy-data-table>
    <el-dialog
      :title="dialogTitle"
      :visible.sync="dialogVisible"
      width="50%"
      custom-class="zlkgl"
      :close-on-click-modal="false"
    >
      <el-form :model="dataForm">
        <el-form-item label="公告标题*">
          <el-input v-model="dataForm.title"></el-input>
        </el-form-item>
       <!--  <el-form-item label="发布者">
          <el-input v-model="dataForm.uploadtor"></el-input>
        </el-form-item> -->
        <el-form-item label="公告内容*">
          <el-input
            type="textarea"
            :rows="4"
            placeholder="请输入内容"
            v-model="dataForm.content"
          >
          </el-input>
        </el-form-item>
      </el-form>
      <span slot="footer" class="dialog-footer">
        <!-- <el-button type="primary" @click="changeStatus"></el-button> -->
        <el-button type="primary" @click="dialogSubmit">提交</el-button>
      </span>
    </el-dialog>
  </div>
</template>
<script>
import carForm from "@/components/form/carForm.vue";
import hyDataTable from "@/components/HyDataTable.vue";
import { requireJson, getdict } from "@/commons/util.js";
import { watch } from 'fs';
export default {
  components: {
    carForm,
    hyDataTable
  },
  data() {
    return {
      dialogVisible: false, //增加修改分类资料弹窗
      submitType: true, //区分请求的是增加还是修改，增加为true,修改为false
      dialogTitle: "", //弹窗标题
      form: {},
      dataClass:[],
      dataForm: {}, //表单
      height: "",
      formitem: [
        "safetyTitle", //安全教育标题
      ],
      loading: false, // 是否加载的标识
      pageRow: 10,
      pageIndex: 1,
      dataTable: {
        list: {
          // "status": "S",
          // "msg": "查询成功",
          // "count": 1,
          // "pageIndex": 1,
          // "pageRow": 10,
          // "data": [
          //     {
          //         "num": "123456",
          //         "carNum": "粤S12345",
          //         "time": "2022-02-23 18:28:36",
          //         "vehicleType": "小型蓝牌",
          //         "color": "蓝",
          //         // "picPath": "http://10.0.6.170:8089/{6E015000-A034-45E9-A476-C90751C29585}.jpg",
          //         "pinType": "奥迪A7",
          //         "typeB": "小型客车",
          //         "device": "治安卡口",
          //         "street": "东莞市XX街道XX大道"
          //     }
          // ]
        },
        columns: [
          { prop: "title", label: "公告标题", minWidth: 90 },
          { prop: "content", label: "公告内容", minWidth: 150 },
          { prop: "createTime", label: "发布时间", minWidth: 120 },
          { prop: "creator", label: "发布者", minWidth: 60 },
          { prop: "statusName", label: "状态", minWidth: 60,html:this.dictionaryChage },
        ],
        buttons: [
          {
            label: "statusName",
            isEnable:true,
            enableName:['生效','失效'],
            click: "map-path",
            perms: 100102,
            // icon: 'fa fa-picture-o',
            type: "info",
            typeName:["success","info"]
          },
          {
            label: "修改",
            click: "detail-handle",
            perms: 100103,
            // icon: 'fa fa-picture-o',
            type: "primary"
          },
          {
            label: "删除",
            click: "del",
            perms: 100102,
            // icon: 'fa fa-picture-o',
            type: "error"
          }
        ],
        paging: {
          pageIndex: 1, // 表格分页信息
          pageRow: 10,
          total: 0
        }
      }
    };
  },
  methods: {
    submit(form) {
      console.log("提交表单", form);
      this.form.title = form.safetyTitle;
      this.pageIndex = 1;
      this.dataTable.paging.pageIndex=1
      this.getData();
    },
    findPage(res1) {
      //console.log("findPage", res1);
      this.pageIndex = res1.pageRequest.pageIndex;
      this.getData();
    },
    //添加
    add(type) {
      this.dialogVisible = true;
     this.dialogTitle = "添加";
     this.submitType = true;
     this.dataForm={};
      //console.log('添加',data)
    },
    //详情
    detailHandle(res) {
      this.dialogVisible = true;
      this.dialogTitle = "修改";
      const data = JSON.parse(JSON.stringify(res.row))
      this.submitType = false;
      this.dataForm=data;
      /*  this.$http
        .GET_tollgateInfo({ paramsID: "/" + data.id })
        .then(response => {
          console.log("详情接口结果", response);
          this.$store.commit("boxDetail", {
            data: response.data,
            title: "详情",
            api: "POST_tollgateUpdata",
            uploadImgApi: this.$apis.POST_tollgateImg,
            sort: this.detailList
          });
        }); */
    },
    //新增修改分类，资料处理方法
    dialogSubmit() {
      console.log('添加修改',this.dataForm);
      if(this.submitType){
       this.$http.POST_hyNoticeAddorUpdate(this.dataForm).then(res=>{
          // console.log('添加',res);
          if(res.status=='S'){
            this.$message.success("添加成功");
             this.pageIndex = 1;
             this.getData();
             this.dialogVisible = false;
          }else{
             this.$message.error("添加失败"+res.msg);
          }
        })
      }else{
        delete this.dataForm.creator;
        delete this.dataForm.createTime;
         this.$http.POST_hyNoticeAddorUpdate(this.dataForm).then(res=>{
          // console.log('添加',res);
          if(res.status=='S'){
            this.$message.success("修改成功");
             this.pageIndex = 1;
             this.getData();
             this.dialogVisible = false;
          }else{
             this.$message.error("修改失败"+res.msg);
          }
        })
      }
    },
    del(res1) {
      console.log("del", res1);
      const data = res1.row;
      this.$confirm('确定要删除吗？', '提示', {
              confirmButtonText: '确定',
              cancelButtonText: '取消',
              type: 'warning'
            }).then(() => {
              this.$http.GET_hyNoticeDel({ paramsID: "/" + data.id}).then(response => {
                this.$message.success("删除成功");
                console.log("删除接口结果", response);
                this.getData()
              });
            }).catch(() => {});
    },
    //公告切换状态
    mapPath(res1){
    //  console.log('ccccccc',res1);
     const id=res1.row.id;
     const statusName=res1.row.statusName==0?1:0;
     this.$http.POST_hyNoticeEnable({id:id,statusName:statusName}).then(response=>{
       if(response.status){
         this.$message.success("公告状态切换成功");
         this.getData()
       }else{
         this.$message.error("添加失败"+res.msg);
       }
     })
    },
    //数据列表
    getData() {
      this.form.pageIndex = this.pageIndex;
      this.form.pageRow = this.pageRow;
      let arr = [];
      this.$http
        .POST_hyNoticeList(this.form)
        .then(response => {
          console.log("列表结果", response);
          this.dataTable.paging.total = response.total;
          if (response.data.records && response.data.records.length > 0) {
                 const records=response.data.records;
            for (var i = 0; i < records.length; i++) {
              // records[i].statusName=this.dictionaryChage(records[i].statusName);
              arr.push(records[i]);
            }
          }
           this.dataTable.list = {
              pageRow: this.pageRow,
              count: response.data.total,
              pageIndex: 1,
              data: []
            };
          this.$set(this.dataTable.list, "data", arr);
          //console.log('展示结果',this.dataTable.list)
        })
        .catch(error => {
          console.log(error);
        });
    },
    //列表字典转换处理
    dictionaryChage(row,val){
      return val==1?'生效':'失效'
    }
  },
  mounted() {
  },
  created() {
  },
};
</script>

<style lang="scss" scoped>
.main_show {
  width: 100%;
  height: 94%;
  display: flex;
  .show_class {
    width: 15%;
    .title {
      background-color: #053b70;
      padding: 10px 0;
      font-weight: 800;
      color: #fff;
      font-size: 14px;
      text-align: center;
      height: 44px;
      line-height: 24px;
    }
  }
  .show_table {
    width: 85%;
  }
}
</style>


// WEBPACK FOOTER //
// src/views/xtgl/gggl.vue